import { HttpClient } from "@angular/common/http";
import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogContent, MatDialogActions, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { env } from "../../../../../env/env";

@Component({
    selector: 'block-client-dialog',
    templateUrl: 'block-client-dialog.html',
    imports: [
        MatButtonModule,
        MatDialogContent,
        MatDialogActions,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlockClientDialog {
    constructor(
        private httpClient: HttpClient,
        private dialogRef: MatDialogRef<BlockClientDialog>,
        @Inject(MAT_DIALOG_DATA) public data: { clientId: string }) {
    }

    public closeDialog(): void {
        this.dialogRef.close(false);
    }

    public blockClient(): void {
        this.httpClient.post(`${env.apiUrl}/clients/${this.data.clientId}/block`, null)
            .subscribe({
                next: _ => this.closeDialog()
            });
    }
}